import { render } from "./tooltip.vue?vue&type=template&id=1d630646"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"

import "./less/tooltip.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__